import { useState, useEffect } from 'react';
import { updateDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase-config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarksLines, faMoneyCheckDollar } from '@fortawesome/free-solid-svg-icons';
import '../../Styles/ExpectedRevenueCard.css'

function ExpectedRevenueCard({ isAdmin, data}) {
  const [omsætning, setOmsætning] = useState(data.expectedValue || "");
  const [bundlinje, setBundlinje] = useState(data.bottomLine || "");  
  const [docId, setDocId] = useState(data.id);

useEffect(() => {
  setOmsætning(data.expectedValue || "");
  setBundlinje(data.bottomLine || "");
  setDocId(data.id);
}, [data]);


  

  const updateValue = async (field, value) => {
    const docRef = doc(db, 'expectedRevenue', docId); 
    await updateDoc(docRef, {
      [field]: value,
    });
  };

  const handleOmsætningChange = async (e) => {
    const newOmsætning = e.target.value;
    setOmsætning(newOmsætning);
    updateValue('expectedValue', newOmsætning);
  };
  
  const handleBundlinjeChange = async (e) => {
    const newBundlinje = e.target.value;
    setBundlinje(newBundlinje);
    updateValue('bottomLine', newBundlinje);
  };
  

  return (
    <>
<div className="col-3  revenue-card">
                <div className="card">
                    <FontAwesomeIcon icon={faMoneyCheckDollar} size='9x' duotone/>
                    <div className="card-body">
                        <h4 className="card-title">Forventet omsætning:</h4>
                        {isAdmin ? (
                            <input
                                type="number"
                                value={omsætning}
                                onChange={handleOmsætningChange}
                                className="card-input"
                            />
                        ) : (
                            <p className="card-text">{`${omsætning}kr`}</p>
                        )}
                    </div>
                </div>
            </div>
            <div className="col-3 revenue-card">
                <div className="card">
                  <FontAwesomeIcon icon={faXmarksLines} size="9x"/>
                    <div className="card-body">
                        <h4 className="card-title">Bundlinje:</h4>
                        {isAdmin ? (
                            <input
                                type="number"
                                value={bundlinje}
                                onChange={handleBundlinjeChange}
                                className="card-input"
                            />
                        ) : (
                            <p className="card-text">{`${bundlinje}%`}</p>
                        )}
                    </div>
                </div>
            </div>
    </>
  );
}
export default ExpectedRevenueCard;
